export default "__VITE_ASSET__CoG5e_Zu__"